import React from 'react';

interface IProps {
  style?: any;
}

const OpenInEditorIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.9445 8.94104L6.08143 0.305025C5.90985 0.133448 5.60483 0 5.37606 0H0.590985C0.228769 0 0 0.228769 0 0.590985V18.3968C0 18.759 0.228769 18.9878 0.590985 18.9878L5.26168 19.045C5.5667 19.045 5.85266 18.9306 6.02424 18.6828L12.9445 10.0467C13.1923 9.7036 13.1923 9.227 12.9445 8.94104Z" fill={props.style?.fillColor ? props.style.fillColor : "#204078"}/>
      <path d="M21.8277 8.94168L14.9075 0.362863C14.6024 0.0006458 14.0877 -0.113738 13.6683 0.248478L12.3148 1.37326C11.8954 1.67828 11.8382 2.26927 12.2004 2.61242L17.8052 9.53267L12.1813 16.5101C11.8763 16.8723 11.9525 17.4633 12.2957 17.7493L13.6683 18.874C14.0877 19.1791 14.5643 19.1028 14.9075 18.7597L21.8277 10.1237C22.0565 9.64705 22.0565 9.22764 21.8277 8.94168Z" fill={props.style?.fillColor ? props.style.fillColor : "#204078"}/>
    </svg>
  )
}

export default OpenInEditorIcon;